import { type TypedSupabaseClient } from '../db/types.ts'
import { parseContact } from './utils.ts'

export async function getContactById(contactId: string, supabase: TypedSupabaseClient) {
  if (!contactId) {
    return null
  }

  const { data, error } = await supabase
    .from('contacts')
    .select(
      `*,
      feedback (
        id,
        created_at,
        updated_at,
        send_at,
        user_id,
        responder_user_id,
        declined_at,
        follow_up_enabled,
        sending_method,
        short_id,
        completed_at,
        opened_at
      )
    `
    )
    .eq('id', contactId)
    .is('deleted_at', null)
    .is('feedback.deleted_at', null)
    .maybeSingle()

  if (error || !data) {
    console.error(error || 'Contact not found')
    return null
  }

  return parseContact(data)
}
